import React from 'react';
import { Sun, Moon, CalendarBlank, CheckCircle, Clock } from 'phosphor-react';

interface RoutineLogModalHeaderProps {
  isMorning: boolean;
  logDate: string;
  stepCount: number;
  duration: string | null;
}

export default function RoutineLogModalHeader({ isMorning, logDate, stepCount, duration }: RoutineLogModalHeaderProps) {
  return (
    <div className={`px-5 py-4 ${isMorning ? 'bg-blush-50 dark:bg-blush-900/20' : 'bg-lavender-50 dark:bg-lavender-900/20'}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {isMorning
            ? <Sun className="w-5 h-5 text-blush-500" />
            : <Moon className="w-5 h-5 text-lavender-500" />
          }
          <span className={`text-sm font-bold ${isMorning ? 'text-blush-600 dark:text-blush-400' : 'text-lavender-600 dark:text-lavender-400'}`}>
            Rotina da {isMorning ? 'Manhã' : 'Noite'}
          </span>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-nude-400 dark:text-gray-500">
          <CalendarBlank className="w-3.5 h-3.5" />
          {logDate}
        </div>
      </div>
      <div className="flex items-center gap-4 mt-3">
        <div className="flex items-center gap-1.5 text-xs font-medium text-gray-600 dark:text-gray-300">
          <CheckCircle className="w-3.5 h-3.5 text-sage-500" />
          {stepCount} etapa{stepCount !== 1 ? 's' : ''} concluída{stepCount !== 1 ? 's' : ''}
        </div>
        {duration && (
          <div className="flex items-center gap-1.5 text-xs font-medium text-gray-600 dark:text-gray-300">
            <Clock className="w-3.5 h-3.5 text-lavender-400" />
            {duration} no total
          </div>
        )}
      </div>
    </div>
  );
}
